module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.svg?84694b2a17e254b828bd6b0fe403c3f6";